import {useEffect, useRef, useState} from "react";
import './sharing-screen.css';

const SharingScreen = ({ sharedBlob, close, showDebug, width, height }) => {
    const imgRef = useRef(null);
    const videoRef = useRef(null);
    const [url, setUrl] = useState("");
    const [contentType, setContentType] = useState("");
    const [file, setFile] = useState(null);
    const [preparing, setPreparing] = useState(false);

    useEffect(() => {
        const content_type = sharedBlob?.type || sharedBlob.type === "image/png" ? "image/png" : "video/mp4";
        const fileExt = sharedBlob.type === "image/png" ? "png" : "mp4";
        const file = new File(
            [sharedBlob],
            `resulted_file.` + fileExt,
            { type: content_type }
        );

        const blobUrl = window.URL.createObjectURL(file);
        setContentType(content_type);
        setUrl(blobUrl);
        setFile(file);
    }, []);

    function closeSharedScreen() {
        close();
    }

    function onLoadStart() {
        setPreparing(true);
    }

    function onCanPlayThrough() {
        setPreparing(false);
    }

    async function share() {
        try {
            navigator.canShare([file]);
            await navigator.share({ files: [file] });
            // close(); <-- do not close preview after sharing
        } catch (error) {
            if (error.message === "Share canceled") return;
            if (error.name === "AbortError") return;
            alert(error.message);
            console.error("SHARED", error);
        }
    }

    return <div className="sharing-screen-container">
        {preparing && <div className='dot-pulse sharing-screen-loader'>
            <div className="splash-centered-box">
                <div className="splash-loader dot-pulse"></div>
            </div>
        </div>}
        {contentType === "image/png" && url && <img ref={imgRef}
                                                    src={url}
                                                    className="shared-content"
                                                    style={{width, height}}
        />}
        {contentType === "video/mp4" && url && <video ref={videoRef}
                                                      src={url}
                                                      autoPlay
                                                      onLoadStart={onLoadStart}
                                                      onCanPlayThrough={onCanPlayThrough}
                                                      loop
                                                      muted
                                                      playsInline
                                                      style={{width, height}}
                                                      className="shared-content"
        />}
        <button className="close-share-screen-button" onClick={closeSharedScreen}></button>
        <button className="share-button" onClick={share}></button>
    </div>
}

export default SharingScreen;
